export enum SapEtaOriginEnum {
  Iftsta = 'IFTSTA',
  Ml = 'ML',
  ShipsGo = 'SHIPSGO',
}
